import { Subscription } from 'rxjs'
import { isReportLoadingState } from './../reports.selectors'
import { CreateReportRequest } from './../reports.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormGroup, FormBuilder, FormControl } from '@angular/forms'

@Component({
  selector: 'app-property-rates-defaulters',
  templateUrl: './property-rates-defaulters.component.html',
  styleUrls: ['./property-rates-defaulters.component.css'],
})
export class PropertyRatesDefaultersComponent implements OnInit, OnDestroy {
  public form: FormGroup
  public isLoading: boolean
  private state$: Subscription

  constructor(private store: Store<any>, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      type: new FormControl('propertyDefaulters'),
      filename: new FormControl('Property Rates Defaulters'),
    })

    this.state$ = this.store
      .pipe(select(isReportLoadingState))
      .subscribe((isLoading: boolean) => {
        this.isLoading = isLoading
      })
  }

  createReport() {
    this.store.dispatch(new CreateReportRequest(this.form.value))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }
}
